import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import UserContext from '../tools/contextLib';
import 'bootstrap/dist/css/bootstrap.min.css';
import { browserName, browserVersion } from 'react-device-detect';
import axios from 'axios';
import { Button, Table, Input, Form } from 'reactstrap';
import moment from 'moment';

export class ContractDates extends Component {
    static displayName = ContractDates.name;

    constructor(props) {
        super(props);
        this.state = {
            returnable: [],
            browser: `${browserName}${browserVersion}`,
            ip: "",
            contractData: []
        }
        this.getUserInfo();
    }

    async getData() {
        const response = await fetch('https://api.ipify.org?format=json', { dataType: 'jsonp' });
        const data = await response.json();
        this.setState({
            ip: data.ip
        })
        //this.recordComingHere();
    }

    async getUserInfo() {
        let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        const response = await fetch('user', { method: 'GET', headers: { 'Authorization': bearerVAR } });
        const data = await response.json();
        localStorage.setItem("lastFetch", moment());
        this.setState({
            returnable: data
        });
        this.getData();
        this.testPermission();
    }

    //async recordComingHere() {
    //    let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
    //    let toSend = {
    //        pagePK: "1035",
    //        department: this.state.returnable.level,
    //        userPCID: this.state.returnable.pcid,
    //        ip: this.state.ip,
    //        browser: this.state.browser,
    //        userID: this.state.returnable.username
    //    }
    //    const response = await fetch('logging', {
    //        method: 'POST',
    //        headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
    //        body: JSON.stringify(toSend)
    //    });
    //    const data = await response.json();
    //    localStorage.setItem("lastFetch", moment());
    //}

    async testPermission() {
        let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let toSend = {
            userLevel: this.state.returnable.level,
            pagepk: "1035"
        }
        const response = await fetch('ValidDepartments', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        })
        const data = await response.json();
        localStorage.setItem("lastFetch", moment());
        this.setState({
            permissionFlag: data
        })
        this.getTableData();
    }

    async getTableData() {
        let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let toSend = {
            userLevel: this.state.returnable.level,
            exectype: "INI"
        }
        const response = await fetch('GetContractDates', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        })
        const data = await response.json();
        localStorage.setItem("lastFetch", moment());
        this.setState({
            contractData: data
        })
    }

    componentDidMount() {

    }

    async buttonClick(type) {
        let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let toSend = {
            userLevel: this.state.returnable.level,
            exectype: type
        }
        const response = await fetch('GetContractDates', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        })
        const data = await response.json();
        localStorage.setItem("lastFetch", moment());
        this.setState({
            contractData: data
        })
    }

    render() {
        if (this.state.permissionFlag == false) {
            this.props.passNewPage(-1);
        }
        if (this.props.justSwitch == true) {
            this.props.passNewPage(1);
        }
        return (
            <div>
                <Button className="inlineCustom" onClick={() => this.buttonClick("ADD")}>Add Next</Button>&emsp;<Button className="inlineCustom" onClick={() => this.buttonClick("DEL")}>Remove First</Button>
                <br />
                <Table striped>
                    <thead>
                        <tr>
                            <th>Term</th>
                            <th>Year</th>
                            <th>Contract Years</th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.state.contractData.map(value => (
                            <tr>
                                <td>{value.term}</td>
                                <td>{value.year}</td>
                                <td>{value.contractyears}</td>
                            </tr>
                            )) }
                    </tbody>
                </Table>
            </div>
        );
    }
}